package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable
data class UtmTags(
    var campaign: String = "",
    var medium: String = "",
    var source: String = ""
)

@Serializable
data class EmailCampaignEventStats(
    val _id: String,
    val count: Int,
    val uniqueCount: Int
)

@Serializable
data class EmailCampaignLinkClick(
    val _id: Int,
    val url: String,
    val count: Int
)

@Serializable
data class EmailCampaignVariantLinkClicks(
    val _id: Int,
    val clicks: List<EmailCampaignLinkClick>
)

@Serializable
data class EmailCampaignStatistics(
    val id: String,
    val variants: List<EmailCampaignVariantStatistics> = listOf(),
    val daysStats: Map<Int, Map<String, EmailCampaignVariantStatistics>> = mapOf(),
    val clicks: List<EmailCampaignVariantLinkClicks> = listOf()
)

@Serializable
data class EmailCampaignVariantStatistics(
    val send: Int = 0,
    val deliveryDelay: Int = 0,
    val delivery: Int = 0,
    val errors: Int = 0,
    val open: Int = 0,
    val openUnique: Int = 0,
    val click: Int = 0,
    val clickUnique: Int = 0,
    val unsubscribe: Int = 0,
    val spam: Int = 0
)

@Serializable
enum class EmailCampaignStatus {
    Template,
    Delayed,
    Preparation,
    Ready,
    Process,
    Pause,
    Complete
}

@Serializable
data class EmailCampaignTitle(
    val id: String,
    val name: String,
    val status: EmailCampaignStatus = EmailCampaignStatus.Template,
    val utmTags: UtmTags,
    var variants: List<EmailCampaignVariant>,
    @Contextual val startDate: Instant? = null,
    var intelligentSending: Boolean = false
)

@Serializable
data class EmailCampaignData(
    var id: String,
    var name: String,
    var store: String,
    var status: EmailCampaignStatus = EmailCampaignStatus.Template,
    @Contextual var startDate: Instant? = null,
    var intelligentSending: Boolean = false,

    var sender: String,

    var subscriptionList: String,
    var segment: Rule.RuleGroup? = null,

    var utmTags: UtmTags = UtmTags(),

    var variants: List<EmailCampaignVariant>
)

@Serializable
data class EmailCampaignVariant(
    var topic: String = "",
    var template: EmailTemplate = EmailTemplate.Freemarker(),
    var finalEmail: String = ""
)